import {Theme} from "../types/ThemeInterface";

//: Theme.Vars
export const Variables = {

  transition: {
    base: "50ms ease",
  },

  font: {
    family: {
      base: "'Inter', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Arial, sans-serif",
      monospace: "Consolas, \"Courier New\", Courier, monospace",
      numeric: "Bahnschrift, \"Segoe UI\", \"Segoe UI Web (West European)\", -apple-system, BlinkMacSystemFont, Roboto, \"Helvetica Neue\", sans-serif",
    }
  },

  borderRadius: {
    small: "6px",
    base: "8px",
    large: "18px",
    full: "999px",
    none: "0px",
  },

  size: {
    base: {
      _default: "2px",
      2: "4px",
      3: "6px",
      4: "8px",
      5: "10px",
      6: "14px",
      7: "18px",
      8: "24px",
      9: "28px",
      10: "34px",
      11: "44px",
      12: "56px",
    }
  },

  zIndex: {
    0: "0",
    1: "1",
    10: "10",
    100: "100",
    full: "999",
  },

  opacity: {
    base: {
      _default: "1",
      2: "0.9",
      3: "0.5",
      4: "0.3",
      5: "0.1",
    }
  },

  backdropBlur: {
    base: "blur(50px)"
  },

  shadow: {
    base: {
      _default: "0 0 4px rgba(0, 0, 0, 0.12),0 1px 3px rgba(0, 0, 0, 0.14)",
      2: "0 0 8px rgba(0, 0, 0, 0.12), 0 10px 18px rgba(0, 0, 0, 0.16)",
      3: "0 0 10px rgba(0, 0, 0, 0.12),0 14px 26px rgba(0, 0, 0, 0.16)",
      4: "0 0 13px rgba(0, 0, 0, 0.12),0 18px 30px rgba(0, 0, 0, 0.16)",
    },
  }
} as const
